module.exports = __webpack_public_path__ + "img/ic-logo-short.7a0aea9e.png";